export const modelSwitch = 'model_switch';
